<h2 mat-dialog-title>Aspektgrupp {{ reportAspectGroupName }}, Behandlade aspekter: {{finalizedTextCount }} av {{ textCount }} </h2>
<form [formGroup]="aspectTextForm" (ngSubmit)="save(true)">
  <mat-dialog-content>
    <div class="flex-row flex-col-ltmd gap-col-1em">
      @if (loadingIndicator) {
        <mat-progress-bar mode="query"></mat-progress-bar>
      }

      <div formArrayName="aspectTexts" >
        <table class="mat-table">
          <thead>
            <tr class="mat-header-row">
              <th class="mat-header-cell left">Namn</th>
              <th class="mat-header-cell left">Bedömning</th>
              <th class="mat-header-cell left">Tidigare bedömning</th>
              <th class="mat-header-cell left"></th>
            </tr>
          </thead>
          <tbody>
            @for (aspectText of aspectTextsArray.controls; track aspectText; let idx = $index) {
              <tr class="mat-row" [formGroupName]="idx" [ngStyle]="getListRowStyle(aspectText.get('reportAspectTextId').value)">
                <td class="mat-cell">{{ aspectText.get("name").value }}</td>
                <td class="mat-cell selectBox">
                  <mat-select formControlName="scoreLevel" placeholder="Välj..." (selectionChange)="selectionChange($event)">
                    <mat-option>Välj...</mat-option>
                    @for (scoreLevel of scoreLevels; track scoreLevel) {
                      <mat-option [value]="scoreLevel[0]">{{ getScoreLevelText(scoreLevel) }}</mat-option>
                    }
                  </mat-select>
                </td>
                <td class="mat-cell selectBox">{{ getScoreLevelName(aspectText.get("previousScoreLevel").value) }}</td>
                <td style="width: 30px" class="mat-cell"><button type="button" mat-icon-button (click)='toggleInfo(aspectText.get("reportAspectTextId").value)'><mat-icon>info</mat-icon></button></td>
              </tr>
            }
            @if (infoReportAspectTextId) {
              <tr class="mat-row">
                <td colspan="4">
                  <h4>{{ 'globalTexts.Scope' | translate }}</h4>
                  <p>{{ info?.scopeDescription }}</p>
                  <h4>{{ 'scoring.ActionsRequired' | translate }}</h4>
                  <p>{{ info?.actionsRequiredDescription}}</p>
                  <h4>{{ 'scoring.Acceptable' | translate }}</h4>
                  <p>{{ info?.acceptableDescription}}</p>
                  <h4>{{ 'scoring.Good' | translate }}</h4>
                  <p>{{ info?.goodDescription}}</p>
                  <h4>{{ 'scoring.VeryGood' | translate }}</h4>
                  <p>{{ info?.veryGoodDescription}}</p>
                  <h4>{{ 'scoring.Excellent' | translate }}</h4>
                  <p>{{ info?.excellentDescription}}</p>
                  <h4>{{ 'scoring.Outstanding' | translate }}</h4>
                  <p>{{ info?.outstandingDescription}}</p>
                  <button type="button" mat-mini-fab (click)='hideInfo()'><mat-icon>arrow_back</mat-icon></button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </mat-dialog-content>
  @if (!infoReportAspectTextId) {
    <mat-dialog-actions>
      @if (hasPermissionToChange$ | async) {
        <button mat-raised-button type="submit"  color="primary" title="{{'commands.SaveAndClose' | translate }}">{{ 'commands.SaveAndClose' | translate }}</button>
      }
      @if (hasPermissionToChange$ | async) {
        <button mat-raised-button type="button" (click)="save(false)" color="accent" title="{{'commands.Save' | translate }}">{{ 'commands.Save' | translate }}</button>
      }
      <button mat-raised-button type="button" (click)="cancel()">{{ 'commands.Close' | translate }}</button>
    </mat-dialog-actions>
  }
</form>
